import { FunctionComponent, useEffect, useState } from "react";
import { LoadingSpinner, PageContainer } from "src/components/generic";
import Article from "src/components/website/Resources/Article";
import TopNav from "src/components/navigation/TopNav";
import { useParams } from "react-router-dom";
import { dynamo } from "src/utils";

const ArticleView: FunctionComponent = () => {
    const [article, setArticle] = useState<Record<any, any>>({});
    const [error, setError] = useState<string>('');
    const { id } = useParams();

    const fetchArticle = async () => {
        if (!id) return;

        try {
            const result = await dynamo.fetch.articleById(id);

            const article = result?.articles?.Items[0]
         
            if (article) setArticle(article);
        } catch (error: any) {
            setError(error?.message || 'Failed to Fetch Article');
        }
    }

    useEffect(() => {
        if(!Object.keys(article).length) fetchArticle()
    }, [])
   
    return (
        <PageContainer>
            <TopNav />
            {
                !Object.keys(article)?.length ? <LoadingSpinner />
                    : <Article article={article} />
            }
        </PageContainer>
    );
}

export default ArticleView;